import { produce } from 'immer';
import { CLEAR_MTT_STATE, CLEAR_TOURNEY_STANDINGS, SET_NUM_MTT_TABLES, UPDATE_TOURNEY_STANDINGS_FROM_INBOUND } from '../actions/mttActions';
const initialState = {
    activePlayers: [],
    finishedPlayers: []
};
const mttReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case CLEAR_MTT_STATE: {
                return initialState;
            }
            case SET_NUM_MTT_TABLES: {
                const numMttTables = action.payload;
                // numMttTables, from the server, could mean 0: not an MTT or -1: closed MTT or no tables remaining
                if (numMttTables !== undefined && numMttTables > 0) {
                    draft.numMttTables = numMttTables;
                }
                else {
                    delete draft.numMttTables;
                }
                break;
            }
            case UPDATE_TOURNEY_STANDINGS_FROM_INBOUND: {
                draft.activePlayers = action.payload.activePlayers;
                draft.finishedPlayers = action.payload.finishedPlayers;
                break;
            }
            case CLEAR_TOURNEY_STANDINGS: {
                draft.activePlayers = [];
                draft.finishedPlayers = [];
                break;
            }
            default: {
                return state;
            }
        }
    });
};
export default mttReducer;
